import { useCallback, useRef } from 'react';
import { StageSubmitRegistrar } from './formik-submit-registrar.component';

// Sink for FormikSubmitRegistrar: dirty child forms register their submit here, and a
// parent-level Save flushes them all before persisting — no child Save button required.
export const usePendingSubmits = () => {
  const pendingRef = useRef(new Map<string, () => Promise<unknown>>());

  const register = useCallback<StageSubmitRegistrar>((id, submit) => {
    if (submit) pendingRef.current.set(id, submit);
    else pendingRef.current.delete(id);
  }, []);

  const flush = useCallback(async () => {
    const pending = Array.from(pendingRef.current.values());
    if (pending.length) await Promise.all(pending.map(submit => submit()));
  }, []);

  const clear = useCallback(() => {
    pendingRef.current.clear();
  }, []);

  return { register, flush, clear };
};
